import { render, staticRenderFns } from "./UbahOutletSettingModal.vue?vue&type=template&id=b57d0a10&scoped=true"
import script from "./UbahOutletSettingModal.vue?vue&type=script&lang=js"
export * from "./UbahOutletSettingModal.vue?vue&type=script&lang=js"
import style0 from "./UbahOutletSettingModal.vue?vue&type=style&index=0&id=b57d0a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57d0a10",
  null
  
)

export default component.exports